import React from 'react';
import { Link } from 'react-router-dom';
import { C, DISP, BODY, MONO } from './shared';

const COLS = [
  {
    title: 'Product',
    links: [['How it works', '#how-it-works'], ['Pricing', '#pricing'], ['Marketing OS', '/marketing-os'], ['Campaign Studio', '/campaign-studio'], ['Blog', '/blog']],
  },
  {
    title: 'Use cases',
    links: [['For founders', '/marketing-for-founders'], ['For ecommerce', '/marketing-for-ecommerce'], ['For creators', '/marketing-for-creators'], ['For SaaS', '/marketing-for-saas'], ['For small businesses', '/marketing-for-small-businesses']],
  },
  {
    title: 'Compare',
    links: [['ScalitOS vs Jasper', '/scalitos-vs-jasper'], ['ScalitOS vs Copy.ai', '/scalitos-vs-copy-ai'], ['ScalitOS vs an agency', '/scalitos-vs-marketing-agency']],
  },
  {
    title: 'Company',
    links: [['Privacy', '/legal/privacy'], ['Terms', '/legal/terms'], ['Contact', 'mailto:hello@scalitos.com']],
  },
];

const FooterLink = ({ label, to }) => {
  const style = { fontFamily: BODY, fontSize: 13.5, color: C.body, transition: 'color 0.2s', display: 'block', padding: '5px 0' };
  const enter = (e) => { e.currentTarget.style.color = C.lime; };
  const leave = (e) => { e.currentTarget.style.color = C.body; };
  if (to.startsWith('mailto:')) return <a href={to} style={style} onMouseEnter={enter} onMouseLeave={leave}>{label}</a>;
  if (to.startsWith('#')) return <a href={to} style={style} onMouseEnter={enter} onMouseLeave={leave}>{label}</a>;
  return <Link to={to} style={style} onMouseEnter={enter} onMouseLeave={leave}>{label}</Link>;
};

export const LandingFooter = () => (
  <footer style={{ borderTop: `1px solid ${C.border}`, padding: '56px clamp(20px, 4vw, 48px) 36px' }}>
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(180px, 100%), 1fr))', gap: 32, marginBottom: 44 }}>
        <div>
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
            <div style={{ width: 26, height: 26, borderRadius: 7, background: C.lime, color: C.bg, display: 'grid', placeItems: 'center', fontFamily: DISP, fontWeight: 800, fontSize: 13 }}>S</div>
            <span style={{ fontFamily: DISP, fontWeight: 700, fontSize: 15, color: C.text }}>ScalitOS</span>
          </Link>
          <p style={{ fontFamily: BODY, fontSize: 13, lineHeight: 1.7, color: C.muted, maxWidth: 220 }}>
            The marketing operating system for founders. Early-access product, built with early-stage founders.
          </p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <p style={{ fontFamily: MONO, fontSize: 10, letterSpacing: '0.2em', color: C.muted, textTransform: 'uppercase', marginBottom: 12 }}>{c.title}</p>
            {c.links.map(([label, to]) => <FooterLink key={label} label={label} to={to} />)}
          </div>
        ))}
      </div>
      <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 24, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 12 }}>
        <p style={{ fontFamily: BODY, fontSize: 12.5, color: C.muted }}>
          &copy; {new Date().getFullYear()} ScalitOS &middot; Built for solo founders
        </p>
        <p style={{ fontFamily: BODY, fontSize: 12.5, color: C.muted }}>
          Brand scans only read publicly visible website content.
        </p>
      </div>
    </div>
  </footer>
);
